import bizTable from '@/biz/bizTable.mjs'

export default bizTable('/listEnableArchMiddlewareType', 'pkid')
